import { Record } from 'immutable';

const keys: ErrorType = {
  status: undefined,
  description: '',
  id: undefined,
  detail: undefined,
  errors: undefined,
};

export interface ErrorType {
  description: string;
  status?: number;
  id?: string;
  detail?: string;
  /** Validation errors returned with the primary API error. */
  errors?: ErrorType[];
}

export class ErrorRecord extends Record<ErrorType>(keys) {
  getDescription() {
    return this.description;
  }
}

export default ErrorRecord;
